module.exports = __webpack_public_path__ + "img/tipo-agila-emt.982e516c.png";